import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-view-vehicle-image',
  templateUrl: './view-vehicle-image.component.html',
  styleUrls: ['./view-vehicle-image.component.scss']
})
export class ViewVehicleImageComponent implements OnInit {

  vehicleImageUrl: string = '';
  vehicleName: string = '';
   constructor(private route: ActivatedRoute) {}

   ngOnInit() {
     this.vehicleImageUrl = this.route.snapshot.params['url'];
     this.vehicleName = this.route.snapshot.params['name'];
   }

}
